import resources from './resources';

const lockerReducers = () => ({
  resourcesState: resources
});

export default lockerReducers;
